async function abTestTracking(data) {
  try {
    if (window?._abt_monster) {
      window._abt_monster.pushEvent(data);
    } else {
      if (!window._abTestTrackingEventStack) {
        window._abTestTrackingEventStack = [];
      }
      window._abTestTrackingEventStack.push(data);
    }
  } catch (error) {
    console.error("Error in abTestTracking", error);
  }
}

export default abTestTracking;
